import React, { useState } from 'react';
import './LandingPage.css';

// Ecrã com os dados Multibanco já atribuídos ao pagamento
// (mostrado quando o cliente reabre o link depois de gerar a referência)
export default function MultibancoDetails({ details }) {
  const { entity, reference, amount, expires_at } = details;

  const [copied, setCopied] = useState('');

  const expiresDate = new Date(Number(expires_at));
  const now = Date.now();

  const expiresLabel = expiresDate.toLocaleString('pt-PT', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  const msLeft = expiresDate.getTime() - now;
  const daysLeft = Math.floor(msLeft / 86400000);
  const hoursLeft = Math.floor(msLeft / 3600000);
  const timeLeftLabel =
    msLeft <= 0
      ? 'expirado'
      : daysLeft >= 1
        ? `${daysLeft} ${daysLeft === 1 ? 'dia' : 'dias'}`
        : `${Math.max(hoursLeft, 1)} ${hoursLeft <= 1 ? 'hora' : 'horas'}`;

  const copyValue = async (label, value) => {
    try {
      await navigator.clipboard.writeText(value.toString().replace(/\s/g, ''));
      setCopied(label);
      setTimeout(() => setCopied(''), 2000);
    } catch (err) {
      console.warn('Não foi possível copiar');
    }
  };

  return (
    <div className="pageContainer">
      <div className="mbCard">
        <div className="mbLogo">MB</div>

        <p className="mbAmount">€{Number(amount).toFixed(2)}</p>

        <p className="mbExpires">
          Expira a {expiresLabel}
          <span className={`mbBadge ${msLeft <= 0 ? 'mbBadgeExpired' : ''}`}>
            {timeLeftLabel}
          </span>
        </p>

        <p className="mbSectionTitle">Detalhes de pagamento</p>

        <div className="mbDetailsBox">
          <div className="mbDetailRow">
            <span className="mbDetailLabel">Entidade</span>
            <span className="mbDetailValue">{entity}</span>
            <button
              type="button"
              className="mbCopyBtn"
              onClick={() => copyValue('entity', entity)}
              title="Copiar entidade"
            >
              {copied === 'entity' ? '✓' : '⧉'}
            </button>
          </div>
          <div className="mbDetailRow">
            <span className="mbDetailLabel">Referência</span>
            <span className="mbDetailValue">{reference}</span>
            <button
              type="button"
              className="mbCopyBtn"
              onClick={() => copyValue('reference', reference)}
              title="Copiar referência"
            >
              {copied === 'reference' ? '✓' : '⧉'}
            </button>
          </div>
        </div>

        <p className="mbNote">
          Pague num terminal Multibanco ou no seu homebanking. Assim que o
          pagamento for confirmado, a sua conta será renovada automaticamente e
          receberá uma notificação.
        </p>
      </div>
    </div>
  );
}
